#ifdef GL_ES
precision mediump float;
#endif

uniform float uGlobalOpacity;

#pragma glslify: snoise = require('../partials/snoise.glsl')

#pragma glslify: fbm = require('../partials/fbm.glsl')

varying vec3 vColor;
varying float vAlpha;
varying float vOpacity;
varying float vRandom;


void main() {
    vec2 coord = gl_PointCoord - vec2(0.5, 0.5);
    float nBorder = snoise(coord * 2.0 + vRandom * 0.5);
    float distortion = nBorder * 0.4;
    coord += distortion;
    float dist = length(coord);
    if (dist > 0.5) discard;


    float inner = 0.1;
    float outer = 0.5;
    float baseFade = smoothstep(outer, inner, dist);

    vec2 st = gl_PointCoord - vec2(0.5, 0.5);
    float noiseF = fbm(st * (2.0 + vRandom * 0.5), vRandom);
    float fade = baseFade * noiseF;

    gl_FragColor = vec4(vColor, vAlpha * vOpacity * uGlobalOpacity * fade);
}
